<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Propuestas</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
            <v-btn class="ma-2" tile large color="teal" icon @click="download()" :disabled="disabledDownload">
                <v-icon small>mdi-file</v-icon>
            </v-btn>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="200px"
            color="#7c167d"
          >
            <template v-slot:activator="{ on, attrs }">
								<v-text-field
                  v-model="dateRangeText"
                  label="Fecha consultar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker v-model="dates" range no-title scrollable color="#7c167d">
              <v-spacer></v-spacer>
              <v-btn text color="#7c167d" @click="menu = false">Cancel</v-btn>
              <v-btn text color="#7c167d" @click="consulta()">OK</v-btn>
            </v-date-picker>
          </v-menu>
      </v-toolbar>
    </template>
  </v-data-table>
</template>

<script>
	import axios from "axios";
	//import Loading from 'vue-loading-overlay';
	import 'vue-loading-overlay/dist/vue-loading.css';
	import XLSX from 'xlsx'
	import {api_url} from '../config/index';

  export default {
    data: () => ({
			disabledDownload: true,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      dates: [],
      dialog: false,
      headers: [
          { text: 'Fecha', value: 'fecha' },
          { text: 'Cotizacion', value: 'cotizacion' },
          { text: 'Propuesta', value: 'propuesta' },
          { text: 'Rut Asegurado', value: 'rutAsegurado' },
          { text: 'Nombre', value: 'nombreAsegurado' },
          { text: 'Marca', value: 'marca' },
          { text: 'Modelo', value: 'modelo' },
          { text: 'Año', value: 'anio' },
          { text: 'Patente', value: 'patente' },
          { text: 'Compañia', value: 'compania' },
          { text: 'Deducible', value: 'deducible' },
          { text: 'Valor Seguro', value: 'valorSeguro' },
          { text: 'Valor Seguro Mensual', value: 'valorSeguroMensual' },
      ],
      desserts: [],
    }),
    computed: {
      dateRangeText () {
        return this.dates.join(' ~ ')
      },
    },
    created () {
    },
    methods: {
        async consulta() {
            console.log('CONSULTA DATOS');
            this.disabledDownload = true; 
            this.menu = false;
            this.isLoading = true
            await axios
            .get(`${api_url}/propuestas?inicio=${this.dates[0]}&fin=${this.dates[1]}`, {
            headers: {
              'user_token': sessionStorage.getItem('token')
            }
          })
            .then(response => {
                this.desserts = response.data.propuestas

                if (this.desserts.length > 0) this.disabledDownload = false; 
                else 
                  this.$swal(
                              'Advertencia!',
                              'No existe información',
                              'warning'
                            )
            })
            .catch(error => {
              console.log(error)
              this.$swal(
                          'Error!',
                          'Error al realizar consulta, ',
                          'error'
                        )
            }).finally(() => this.isLoading = false); 
        },
        download() {
            let data = XLSX.utils.json_to_sheet(this.desserts)
            const workbook = XLSX.utils.book_new()
            const filename = 'cotizaciones'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xlsx`)
        }
	},	
  }
</script>